import * as React from 'react';
import {Wrapper, Item} from '@packages/systems/design-system/Menu';
import Hitarea from '@packages/systems/design-system/Hitarea';
import {styled} from '@packages/utilities/styled';
import {weakMemo} from '@packages/utilities/memo';
import type {LabelItemResult} from '@packages/systems/ExpressionEditor-custom-controls';

type Props = {
  style?: Record<any, any> | null | undefined;
  items: Array<LabelItemResult>;
  closePopover: () => void;
};

const withEffect = weakMemo((effectFn: () => void) => (fn: any) =>
  // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
  (...args) => {
    effectFn();
    return fn(...args);
  }
);

// @ts-expect-error - TS7031 - Binding element 'theme' implicitly has an 'any' type.
const itemStyle = ({theme}) => {
  return {
    padding: `${theme.gutters.base}px ${theme.gutters.x8}px`,
    margin: `${theme.gutters.base}px 0`,
    minHeight: theme.control.height,
  };
};

const propertyMenuItemVariants = {
  // @ts-expect-error - TS7031 - Binding element 'colors' implicitly has an 'any' type. | TS7031 - Binding element 'noHover' implicitly has an 'any' type.
  hover: ({theme: {colors}, noHover}) =>
    noHover
      ? {}
      : {
          color: colors.foregroundVivid,
          background: colors.control,
        },
  // @ts-expect-error - TS7031 - Binding element 'theme' implicitly has an 'any' type.
  bottom: ({theme}) => ({
    padding: `0 ${theme.gutters.x8}px`,
    margin: `0 0 ${theme.gutters.base}px`,
  }),
} as const;

// @ts-expect-error - TS2769 - No overload matches this call. | TS2345 - Argument of type '{ readonly hover: ({ theme: { colors }, noHover }: { theme: { colors: any; }; noHover: any; }) => { readonly color?: undefined; background?: undefined; } | { color: any; background: any; }; readonly bottom: ({ theme }: { theme: any; }) => { padding: string; margin: string; }; }' is not assignable to parameter of type 'VariantMap<(Omit<any, "ref"> & RefAttributes<any>) | (Omit<any, "ref"> & RefAttributes<any> & { children?: ReactNode; })>'.
const StyledMenuItem = styled(Item)(itemStyle, propertyMenuItemVariants);

const StyledPropertyMenuGridLayout = styled('div')(({theme: {gutters}}) => ({
  display: 'grid',
  gridTemplateColumns: `auto 1fr auto`,
  gap: `${gutters.base}px ${gutters.base * 2}px`,
}));

export const SETTINGS_PANEL_PROPERTY_MENU_AUTOMATION_ID =
  'settings-panel-property-menu';

export const SettingsPanelPropertyMenu = ({
  style,
  items,
  closePopover,
}: Props) => {
  return (
    <Wrapper
      style={style}
      data-automation-id={SETTINGS_PANEL_PROPERTY_MENU_AUTOMATION_ID}
    >
      {items.map(({content, clickable}, idx) => (
        <React.Fragment key={idx}>
          {content}
          {clickable ? (
            <Hitarea>
              <StyledMenuItem
                onClick={withEffect(closePopover)(clickable.onClick)}
              >
                <StyledPropertyMenuGridLayout>
                  {clickable.content}
                </StyledPropertyMenuGridLayout>
              </StyledMenuItem>
            </Hitarea>
          ) : null}
        </React.Fragment>
      ))}
    </Wrapper>
  );
};
